export const CIRCULAR_PROGRESS_BAR_VARIANTS = ["full", "half"] as const;
export const CIRCULAR_PROGRESS_BAR_SIZES = ["small", "medium"] as const;
export const CIRCULAR_PROGRESS_BAR_START_POSITIONS = ["top", "bottom", "left", "right"] as const;
export const CIRCULAR_PROGRESS_BAR_ROTATIONS = ["clockwise", "counterclockwise"] as const;

export type CircularProgressBarVariant = (typeof CIRCULAR_PROGRESS_BAR_VARIANTS)[number];
export type CircularProgressBarSize = (typeof CIRCULAR_PROGRESS_BAR_SIZES)[number];
export type CircularProgressBarStartPosition = (typeof CIRCULAR_PROGRESS_BAR_START_POSITIONS)[number];
export type CircularProgressBarRotation = (typeof CIRCULAR_PROGRESS_BAR_ROTATIONS)[number];

interface CircularProgressBarSizeDimensions {
  radius: number;
  strokeWidth: number;
}

export const CIRCULAR_PROGRESS_BAR_SIZE_DIMENSIONS: Record<CircularProgressBarSize, CircularProgressBarSizeDimensions> =
  {
    small: {
      radius: 15,
      strokeWidth: 5,
    },
    medium: {
      radius: 22,
      strokeWidth: 5,
    },
  };

export interface CircularProgressBarProps {
  value: number;
  variant?: CircularProgressBarVariant;
  size?: CircularProgressBarSize;
  startPosition?: CircularProgressBarStartPosition;
  rotation?: CircularProgressBarRotation;
  progressColor?: string;
  backgroundColor?: string;
  text?: string;
  textClassName?: string;
  textColor?: string;
}
